import jquery from 'jquery'

window.$ = window.jQuery = jquery

// Custom fullscreen button
window.FullscreenButton = class FullscreenButton {
    mount (rootElem) {
        this.button = document.createElement('div')
        this.button.setAttribute('class', 'w-fullscreen')
        this.button.innerHTML = '<img src="https://services.iphonephotographyschool.com/modules/forms/media/plc/fullscreen.svg" alt="fs">'
        this.button.style.opacity = 0
        this.button.style.transition = 'opacity 200ms ease'
        rootElem.addEventListener('click', this.onClick)
        rootElem.appendChild(this.button)
    }
    onClick () {
        // Delegate click action to Wistia default fullscreen button
        // in order for this feature to work on mobile browsers
        document.querySelector('[data-handle="fullscreenButton"] button').click()
    }
    onControlPropsUpdated () {
        this.button.style.opacity = this.props.controlsAreVisible ? 1 : 0
    }
}

FullscreenButton.handle = 'fullscreenVideo'
FullscreenButton.type = 'above-control-bar'
FullscreenButton.sortValue = 50

// Check if device is mobile
window.isMobile = function () {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    && !window.MSStream) {
        return true
    }
    return false
}

// Check if device is iPad
window.isIPad = function () {
    if(/iPad/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) && !window.MSStream) {
        return true
    }
}

// iPad 100% height without scroll hack
function getAppHeight () {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}

function iPadHeightFix () {
    window.addEventListener('resize', getAppHeight)
    getAppHeight()
}
iPadHeightFix()
